import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { getCasePriorityLabel } from '../../../lib/casePriority';

const UrgentCaseCard = ({ caseData }) => {
  const navigate = useNavigate();

  const getPriorityColor = (priority) => {
    const colors = {
      urgente: 'var(--color-error)',
      urgent: 'var(--color-error)',
      express: 'var(--color-warning)',
      high: 'var(--color-warning)',
      normal: 'var(--color-accent)',
      medium: 'var(--color-accent)',
      low: 'var(--color-muted-foreground)',
    };
    return colors?.[priority] || 'var(--color-muted-foreground)';
  };

  const getPriorityLabel = (priority) =>
    getCasePriorityLabel(priority) || priority;

  const handleClick = () => {
    navigate('/case-detail', { state: { caseId: caseData?.id } });
  };

  return (
    <div
      onClick={handleClick}
      className="bg-card border border-border rounded-lg p-4 cursor-pointer transition-all duration-200 hover:shadow-interactive hover:border-primary/30"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-semibold text-foreground">#{caseData?.caseNumber}</span>
            <span
              className="px-2 py-0.5 text-xs font-medium rounded-full"
              style={{
                backgroundColor: `${getPriorityColor(caseData?.priority)}15`,
                color: getPriorityColor(caseData?.priority),
              }}
            >
              {getPriorityLabel(caseData?.priority)}
            </span>
          </div>
          <p className="text-sm text-foreground font-medium">{caseData?.patientName}</p>
        </div>
        <Icon name="AlertCircle" size={20} color={getPriorityColor(caseData?.priority)} />
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Calendar" size={14} />
          <span>Échéance: {caseData?.dueDate}</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="User" size={14} />
          <span>{caseData?.dentist}</span>
        </div>
        {caseData?.reason && (
          <p className="text-xs text-muted-foreground mt-2">{caseData?.reason}</p>
        )}
      </div>
    </div>
  );
};

export default UrgentCaseCard;